import React from 'react'
import Edit from '../crud/edit'
import menuItems from './menuItems'

const EditHomeworkTask = (props) => {
  return (
    <Edit
// @ts-ignore
      title='Editing Homework Task'
      fields={require('./fields')(props.params.homeworkId)}
      apiPath={`admin/homework_tasks/${props.params.homeworkTaskId}`}
      successRedirectPath={`/write-now/homework/${props.params.homeworkId}/tasks?filters[homework_id]=${props.params.homeworkId}`}
      buildMenuItems={menuItems}
    />
  )
}

export default EditHomeworkTask
